import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'

/**
 * This basic component is for displaying a standard label in the section 8
 * results.
 * Primarily for standardized styling and responsiveness
 * of this type of element.
 */
export default class Section8RowLabel extends Component {
  /**
   * Render component
   * @returns {XML}
   */
  render () {
    const rowStyle = {
      paddingTop: 25,
      paddingBottom: 10
    }
    return (
      <Row style={rowStyle}>
        <Col md={2} lg={1} />
        <Col md={10} lg={11}>
          <span style={this.props.style}>{this.props.text}</span>
        </Col>
      </Row>
    )
  }
}

Section8RowLabel.propTypes = {
  text: PropTypes.string.isRequired,
  style: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/sections/Section8RowLabel.js